import type {TFunction} from 'i18next'
import {Tag} from '@/components/ui/tag'
import type {Column} from '@/components/data-table'
import type {Business} from '@/hooks/empresa/organizacion/use-businesses'
import {SYSTEM_NIT} from '@/lib/constants'

/** Columnas nombre + NIT de toda tabla de empresas; cada llamador agrega las suyas detrás. */
export function businessNameNitColumns(t: TFunction): Column<Business>[] {
  return [
    {
      key: 'name',
      header: t('businesses.table.name'),
      sortable: true,
      cell: (b) => (
        <span className="flex items-center gap-2 font-medium text-foreground">
          <span className="truncate">{b.name}</span>
          {b.nit === SYSTEM_NIT && <Tag tone="ink">{t('businesses.systemTag')}</Tag>}
          {b.origen === 'servicio' && <Tag tone="neutral">{t('businesses.servicioTag')}</Tag>}
        </span>
      ),
    },
    {
      key: 'nit',
      header: t('businesses.table.nit'),
      sortable: true,
      // Angosta en móvil: a 390px el nombre, que es lo que identifica la fila, necesita el ancho.
      width: 'w-20 sm:w-36',
      cell: (b) => <span className="block truncate font-mono text-xs text-muted-foreground">{b.nit}</span>,
    },
  ]
}
